




















































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    EventsServiceContract,
    WindowsServiceContract,
} from '@/core/contracts';
import store, {
    ConnectionStatusState,
    UserState,
    IndicatorsState,
    SettingsState
} from '@/store';
import { ConnectionStatus } from '@/dto/ConnectionStatus';
import { localize } from '@/core/filters';
import { DxPopup } from 'devextreme-vue/popup';

@Component({ components: { DxPopup } })
export default class ConnectionStatusInfo extends Vue {
    @Inject(CONTRACTS.EventsService)
    private eventsService?: EventsServiceContract;
    @Inject(CONTRACTS.WindowsService)
    private windowsService?: WindowsServiceContract;

    private currentVersion?: string;
    private popupVisible: boolean = false;
    private previousOfflineStatus: number = -1;

    public get connected() {
        this.verifVersionAndUpdateOrTileUpdate();
        return ConnectionStatusState.onlineStatus;
    }

    public get autoReconnect() {
        return SettingsState.contextSettings.global.autoReconnect === undefined
            ? true
            : SettingsState.contextSettings.global.autoReconnect;
    }

    public reConnect() {
        ConnectionStatusState.changeStatus(2);
        this.eventsService!.reconnect();
    }

    private async verifVersionAndUpdateOrTileUpdate() {
        if (ConnectionStatusState.onlineStatus === ConnectionStatus.Connected) {
            await UserState.fetchUser();
            if (
                this.currentVersion !== undefined &&
                this.currentVersion !== SettingsState.server.version!
            ) {
                this.windowsService!.showDialog(
                    localize('Context_ConnectionStatusMessage_NewVersion')
                ).then(() => {
                    location.reload();
                });
            } else {
                if (this.previousOfflineStatus === 0) {
                    IndicatorsState.fetchIndicators();
                    const tiles = this.windowsService!.getLayout();
                    this.windowsService!.closeAll();
                    tiles.forEach(tile => {
                        this.windowsService!.update(tile.name, tile.args);
                    });
                }
            }
            this.currentVersion = SettingsState.server.version!;
        }
        if (
            ConnectionStatusState.onlineStatus ===
                ConnectionStatus.Disconnected ||
            ConnectionStatusState.onlineStatus ===
                ConnectionStatus.TempDisconnect
        ) {
            this.previousOfflineStatus = ConnectionStatusState.onlineStatus;
        }
    }
}
